const DESKTOP_BREAKPOINT = 1199

const SELECTORS = {
  cityLink: 'city-op-input',
  desktopInput: 'searchGeneral',
  desktopAutocomplete: 'desktopSearchAutocomplete',
  mobileToggle: 'bt_modalSearch_mobile',
  mobileInput: 'mobileSearchInput',
  mobileAutocomplete: 'mobileSearchAutocomplete',
  mobileWrapper: '[data-id="mobile-search"]'
}

const SUPPRESS_MAIN_SEARCH_TRACKING_ATTR = 'data-suppress-menu-main-search-tracking'

const getElement = (id) => document.getElementById(id)

const isDesktopViewport = () => $(window).outerWidth() > DESKTOP_BREAKPOINT

const focusInput = (input) => {
  if (!input) return

  input.setAttribute(SUPPRESS_MAIN_SEARCH_TRACKING_ATTR, 'true')
  input.setAttribute('aria-expanded', 'true')
  input.focus()

  setTimeout(() => {
    input.removeAttribute(SUPPRESS_MAIN_SEARCH_TRACKING_ATTR)
  }, 0)
}

const showDesktopAutocomplete = () => {
  const desktopInput = getElement(SELECTORS.desktopInput)
  const desktopAutocomplete = getElement(SELECTORS.desktopAutocomplete)

  if (!desktopInput || !desktopAutocomplete) return

  desktopAutocomplete.style.display = 'flex'
  focusInput(desktopInput)
}

const showMobileAutocomplete = () => {
  const mobileToggle = getElement(SELECTORS.mobileToggle)
  const mobileInput = getElement(SELECTORS.mobileInput)
  const mobileAutocomplete = getElement(SELECTORS.mobileAutocomplete)

  if (!mobileInput || !mobileAutocomplete) return

  const wrapper = document.querySelector(SELECTORS.mobileWrapper)

  if (wrapper) {
    $(wrapper).stop(true, true).slideDown('fast')
    mobileAutocomplete.style.display = 'flex'
    focusInput(mobileInput)

    if (mobileToggle) {
      mobileToggle.setAttribute('aria-expanded', 'true')
    }

    return
  }

  const isVisible = window.getComputedStyle(mobileAutocomplete).display === 'flex'

  if (!isVisible) {
    mobileAutocomplete.style.display = 'flex'
  }

  if (mobileToggle) {
    mobileToggle.setAttribute('aria-expanded', 'true')
  }

  focusInput(mobileInput)
}

const handleCityLinkClick = () => {
  const cityLink = getElement(SELECTORS.cityLink)

  if (!cityLink) return

  cityLink.removeEventListener('click', cityLink._fiftCityLinkHandler)

  cityLink._fiftCityLinkHandler = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (isDesktopViewport()) {
      showDesktopAutocomplete()
      return
    }

    showMobileAutocomplete()
  }

  cityLink.addEventListener('click', cityLink._fiftCityLinkHandler)
}

export default handleCityLinkClick
